import React, { createRef, useEffect, useState } from 'react'

import Show from '../../../utils/show'
import ButtonClose from '../../atoms/button-close/button-close'
import Button from '../../atoms/button/button'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import CanvasCardMaker from '../../atoms/canvasCardMaker/canvasCardMaker'
import { cardsStore, marcasDeAgua } from './cardsStore'
import AppSlider from '../../atoms/appSlider/appSlider'
import ModalRedeem from '../modalRedeem/modalRedeem'
import getUserInfo from '../../../utils/getUserInfo'
import './modalDesignCard.scss'
import { TROPICALIZED } from '../../../constants/activity-constants'

const SliderCardSelector = ({ index = 0, onChange }) => {
  const isMobile = useMediaQuery()
  const settings = {
    initialSlide: index,
    afterChange: onChange,
  }

  return (
    <div className="f-modal-design-card__slider ">
      <p className="f-modal-design-card__text --helper ">
        {TROPICALIZED ? 'Hacé' : 'Haz'} clic en las flechas para{' '}
        {isMobile && <br />} seleccionar otra plantilla
      </p>
      <AppSlider settings={settings}>
        {cardsStore.map((card, index) => {
          return (
            <img
              key={index}
              src={card.preview}
              className="f-modal-design-card__slider__item "
            />
          )
        })}
      </AppSlider>
    </div>
  )
}

const InputFile = ({ handler }) => {
  let inputFileCallback = () => {}
  const inputFileRef = createRef()
  var fileTypes = ['jpg', 'jpeg', 'png', 'webp'] //acceptable file types

  const listenToInput = () => {
    inputFileRef.current.addEventListener('change', function () {
      var extension = this.files[0].name.split('.').pop().toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1 //is extension in acceptable types
      if (isSuccess) {
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          inputFileCallback(reader.result)
        })
        reader.readAsDataURL(this.files[0])
      } else {
        handler.onFail()
      }
    })
  }
  handler.upload = _callback => {
    if (inputFileRef) {
      inputFileRef.current.click()
      if (_callback) {
        inputFileCallback = _callback
      }
    }
  }
  useEffect(() => {
    if (inputFileRef) {
      listenToInput()
    }
  }, [inputFileRef])
  return (
    <input
      type="file"
      id="image-input"
      accept="image/png, image/jpeg, image/webp"
      ref={inputFileRef}
      style={{ display: 'none', width: '0px', height: '0px' }}
    />
  )
}

const ModalDesignCard = ({ onClose, onSuccess }) => {
  const [card, setCard] = useState(0)
  const [step, setStep] = useState(1)
  const [storedCard, setStoredCard] = useState(null)
  const [onRedeem, setOnRedeem] = useState(false)
  const [fotoImage, setFotoImage] = useState(null)
  const [userMessage, setUserMessage] = useState(null)
  const userInfo = getUserInfo()
  const handlerInputFile = {
    upload: () => {}, //to be override
    onFail: () => {
      setUserMessage('Archivo Incompatible')
    },
  }
  const handlerCanvas = {
    download: () => {}, //to be override
  }

  const getCard = () => {
    return cardsStore[card]
  }
  const closeHandler = () => {
    // clear
    onClose && onClose()
  }
  const onRedeemSuccess = () => {
    downloadStoredContent('Tarjeta Navideña')
    onSuccess && onSuccess()
  }

  const triggerFileUpload = () => {
    setUserMessage('')
    handlerInputFile.upload(dataImage => {
      setFotoImage(dataImage)
      setStep(3)
    })
  }
  const goBack = () => {
    setUserMessage('')
    setStep(step > 0 ? step - 1 : 0)
  }
  const downloadStoredContent = (filename = 'imagen') => {
    var link = document.createElement('a')
    link.download = filename + '.png'
    link.href = storedCard
    link.click()
  }
  const downloadPhoto = () => {
    setStoredCard(handlerCanvas.getContent())
    setOnRedeem(true)
  }
  const getMetric = category => {
    return {
      event: 'Interacciones_Diseño_Tarjeta',
      category,
      action: 'click',
      label: '',
      card_name: 'Mi parte favorita de la Navidad son ustedes',
      Location: 'nosotras.com/navidad',
      user_data: [
        {
          nombre: userInfo.name,
          apellido: userInfo.lastName,
          celular: userInfo.cellPhone,
          correo: userInfo.email,
          ciudad: userInfo.location.cityName,
          departamento: userInfo.location.countryStateName,
          pais: userInfo.countryName,
        },
      ],
      log_status: 'Yes',
    }
  }

  if (onRedeem) {
    return (
      <ModalRedeem
        activity={'card'}
        onSuccess={() => {
          setOnRedeem(false)
          onRedeemSuccess()
        }}
        onClose={() => {
          setOnRedeem(false)
        }}
      />
    )
  }

  return (
    <div className="f-modal-design-card">
      <ButtonClose
        className="f-modal-design-card__close "
        onClick={closeHandler}
        title="cerrar modal y regresar al home"
      />

      <article
        className={'f-modal-design-card__container ' + ('--step' + step)}
      >
        <aside className="f-modal-design-card__aside --first --center">
          <Show valid={step === 1}>
            <SliderCardSelector
              index={card}
              onChange={_index => {
                setCard(_index)
              }}
            />
          </Show>
          <Show valid={step === 2}>
            <CanvasCardMaker
              marcasAgua={marcasDeAgua}
              backgroundImage={getCard().image}
              className="--gift-card-dimensions "
            />
            <InputFile handler={handlerInputFile} />
          </Show>
          <Show valid={step === 3}>
            <div className="--center --column">
              <p className="f-modal-design-card__text --helper ">
                Arrastra la imagen para centrarla donde quieras
              </p>
              <CanvasCardMaker
                marcasAgua={marcasDeAgua}
                backgroundImage={getCard().image}
                mask={getCard().mask}
                frontalImage={fotoImage}
                handler={handlerCanvas}
                className="--gift-card-dimensions "
              />
            </div>
          </Show>
        </aside>
        <aside className="f-modal-design-card__aside --last">
          <Show valid={step === 1}>
            <h3 className="f-modal-design-card__title">
              ¡{TROPICALIZED ? 'Seguí' : 'Sigue'} estos pasos!
            </h3>
            <p className="f-modal-design-card__text --center-text">
              <span className="number">1.</span>{' '}
              {TROPICALIZED ? 'Elegí' : 'Elige'} la plantilla que más
              <br /> te guste.
            </p>
            <div className="f-modal-design-card__actionbuttons ">
              <Button
                className="--center"
                metric={getMetric('Plantilla')}
                onClick={e => {
                  setStep(2)
                }}
                text={'Continuar'}
              />
            </div>
          </Show>

          <Show valid={step === 2}>
            <h3 className="f-modal-design-card__title">
              ¡{TROPICALIZED ? 'Seguí' : 'Sigue'} estos pasos!
            </h3>
            <p className="f-modal-design-card__text">
              <span className="number">2.</span>
              {TROPICALIZED ? 'Subí' : 'Sube'} una foto con tu persona favorita
            </p>

            <div className="f-modal-design-card__actionbuttons ">
              <Button
                className="--center"
                metric={getMetric('Agregar foto')}
                onClick={triggerFileUpload}
                text={'Subir Foto'}
              />

              <Button
                className="--center"
                metric={getMetric('Agregar foto')}
                onClick={goBack}
                text={'Volver'}
              />
            </div>
          </Show>

          <Show valid={step === 3}>
            <h3 className="f-modal-design-card__title">
              Así se verá tu tarjeta
            </h3>
            <p className="f-modal-design-card__text --center">
              ¿Te gusta? <br /> <br />
              <Show valid={TROPICALIZED}>Descargala y compartila.</Show>
              <Show valid={TROPICALIZED === false}>
                Descárgala y compártela.
              </Show>
            </p>
            <div className="f-modal-design-card__actionbuttons  ">
              <Button
                className="--center"
                metric={getMetric('Así se verá tu tarjeta')}
                onClick={downloadPhoto}
                text={'¡La quiero ya!'}
              />

              <Button
                className="--center"
                metric={getMetric('Así se verá tu tarjeta')}
                onClick={goBack}
                text={'Volver'}
              />
            </div>
          </Show>
          <p className="f-modal-design-card__text --error "> 
            {userMessage}
          </p>
        </aside>
      </article>
    </div>
  )
}
export default ModalDesignCard
